import { useQuery } from "@tanstack/react-query";
import BankMpProvider from "@/core/data-provider/data-mp/bank/bank-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";

export function useBankTariffsQuery({ enabled }: { enabled: boolean }) {
  return useQuery({
    queryKey: ["bank-tariffs"],
    queryFn: async () => {
      const response = await BankMpProvider.getBankTariffs();

      if (response instanceof RpcMpProviderFailedResponse) {
        throw new Error(response.message);
      }

      return response.data.filter((tariff) => tariff.isActive);
    },
    select: (data) => ({
      minServicePrice: Math.min(...data.map((tariff) => tariff.price)),
      tariffs: data.map((tariff) => ({
        ...tariff,
      })),
    }),
    enabled,
  });
}
